import { heroStats } from '@/mocks/content';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[600px] h-[92vh] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=atmospheric%20cinema%20hall%20at%20night%20seen%20from%20the%20back%2C%20rows%20of%20empty%20red%20velvet%20seats%2C%20a%20beam%20of%20warm%20projector%20light%20cutting%20through%20haze%20toward%20a%20glowing%20screen%2C%20deep%20charcoal%20and%20warm%20amber%20tones%2C%20cinematic%20wide%20composition%2C%20film%20grain%2C%20no%20text&width=1920&height=1080&seq=hero-starry-cinema&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent" />

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400" />
            星辰影院 · 最新电影与院线动态一站浏览
          </span>

          <h1 className="mt-5 text-3xl md:text-6xl font-black leading-[1.12] text-background-50">
            星辰影院最新电影
            <span className="block text-accent-300 mt-1">新片上映 · 院线同步 · 热播大片</span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-lg text-foreground-200 leading-relaxed">
            本站围绕「星辰影院最新电影」整理今日更新、新片上映、院线同步与热播大片，并汇总 2024 新片与每天的变化。
            你可以在这一页里按上映阶段挑选，也可以直接用类型标签和关键词缩小范围，找到今天想看的那一部。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#today"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-flashlight-line text-lg" />
              浏览今日更新
            </a>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap backdrop-blur-sm hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              <i className="ri-fire-line text-lg" />
              查看热播榜单
            </a>
          </div>
        </div>

        <dl className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl">
          {heroStats.map((stat) => (
            <div key={stat.label} className="border-l-2 border-accent-400/70 pl-3">
              <dt className="text-xl md:text-3xl font-black text-background-50 font-heading">{stat.value}</dt>
              <dd className="mt-1 text-xs md:text-sm text-foreground-300">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}